import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeInsuranceListService = (
  params: Types.EmployeeInsuranceListRequest
) =>
  RestAPIClient.call<Types.EmployeeInsuranceListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List.replace("{employeeId}", params.employeeId.toString())}`,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeInsuranceCreateService = (
  params: Types.EmployeeInsuranceCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeInsurance>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeInsuranceUpdateService = (
  params: Types.EmployeeInsuranceUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeInsurance>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeInsuranceDeleteService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.EmployeeInsurance>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeInsuranceDetailService = ({
  employeeId,
}: {
  employeeId: number;
}) =>
  RestAPIClient.call<Types.EmployeeInsurance>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{employeeId}", employeeId.toString())}`,
    config: {
      requireAuthentication: true,
    },
  });
